import './iconeWhatsApp.css'
import iconeWhatsApp from '../../assets/icons/whatsapp.png'

export default function IconeWhatsApp(){
    return(
        <a
            href="https://wa.me/5531996188853"
            target="_blank"
            rel="noopener noreferrer"
            className="whatsapp"
            >
            <img className='icone' src={iconeWhatsApp} />
        </a>
    )
}